import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useServerData } from '@xingternal/hops';
import { BodyCopy } from '@xingternal/typography';

import { XING_PRIVACY_LINK_DE, XING_PRIVACY_LINK_EN, routes } from '@/config';
import { ConversionType, ConvertedReplySettingsJob, JobApplicationFormExternalDoc, Maybe } from '@/graphql/generated';
import { useLoginStates } from '@/hooks';

import { ExternalDocuments } from './external-documents';

type Props = {
  externalDocuments?: Maybe<JobApplicationFormExternalDoc>[];
  replySettings?: Maybe<Omit<ConvertedReplySettingsJob, 'id'>>;
};

export const PrivacyPolicyLinks: React.FC<Props> = ({ externalDocuments, replySettings }) => {
  const { isLoggedIn } = useLoginStates();
  const { language } = useServerData();
  const showConvertedJobEmailInfo =
    replySettings?.conversionType === ConversionType.UrlTypeWithDescriptionEmail && replySettings.converted;

  return (
    <>
      {showConvertedJobEmailInfo ? (
        <BodyCopy>
          <FormattedMessage
            id="JOBS_POSTING_XING_APPLY_INFO_SENDER_EMAIL_ADDRESS"
            values={{ replyEmail: replySettings.replyEmail }}
          />{' '}
        </BodyCopy>
      ) : null}
      {!isLoggedIn && (
        <>
          <BodyCopy lineHeight="dense">
            <FormattedMessage
              id="JOBS_POSTING_APPLY_FORM_LO_XING_TERMS_AND_PRIVACY"
              values={{
                a1: (chunks) => (
                  <a href={routes.terms} target="_blank" rel="noreferrer">
                    {chunks}
                  </a>
                ),
                a2: (chunks) => (
                  <a
                    href={language === 'de' ? XING_PRIVACY_LINK_DE : XING_PRIVACY_LINK_EN}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {chunks}
                  </a>
                ),
              }}
            />
          </BodyCopy>{' '}
        </>
      )}
      {externalDocuments && externalDocuments.length > 0 ? (
        <ExternalDocuments externalDocuments={externalDocuments as JobApplicationFormExternalDoc[]} />
      ) : (
        <BodyCopy>
          <FormattedMessage id="JOBS_POSTING_XING_APPLY_NO_PRIVACY_POLICY_LINKS" />
        </BodyCopy>
      )}
    </>
  );
};
